import {
  DATA_VERSION_HEADER,
  DataVersion,
  UNIFIED_DATA_VERSION,
} from '@hakimo-ui/hakimo/types';
import { isUnifiedDataVersion } from './is-unified-data-version';

/**
 * Pins a request to the unified dataset by setting the `X-Data-Version` header.
 *
 * Mutates `request` in place (a `Request` built in a hook body is not shared,
 * so this is safe) and returns it so it can be used inline.
 *
 * Only `v3` is ever sent. `v2`/`null`/`undefined` leave the request untouched,
 * so a legacy read is byte-identical to a pre-unification one. The gate lives
 * here rather than at the call sites so no caller can put `v2` on the wire by
 * passing a raw `DataVersion` through — same rule as `appendVersionParam`.
 */
export function withDataVersion(
  request: Request,
  dataVersion?: DataVersion
): Request {
  if (isUnifiedDataVersion(dataVersion)) {
    request.headers.set(DATA_VERSION_HEADER, UNIFIED_DATA_VERSION);
  }
  return request;
}
